import { 
  DashboardOutlined,
  UsergroupAddOutlined,
  ReconciliationOutlined,
  MessageOutlined
} from '@ant-design/icons';
import { APP_PREFIX_PATH } from 'configs/AppConfig'

const dashBoardNavTree = [{
  key: 'home',
  path: `${APP_PREFIX_PATH}/home`,
  title: 'home',
  icon: DashboardOutlined,
  breadcrumb: false,
  submenu: []
}]

const studentManage = [{
  key: '',
  path: `${APP_PREFIX_PATH}/student`,
  title: 'sidenav.student',
  icon: '',
  breadcrumb: false,
  submenu: [
     {
      key: 'student',
      path: `${APP_PREFIX_PATH}/student`,
      title: 'sidenav.student',
      icon: UsergroupAddOutlined ,
      breadcrumb: false,
      submenu:[
        {
          key: 'student-enrollment',
          path: `${APP_PREFIX_PATH}/student/enrollment`,
          title: 'sidenav.student.enrollment',
          icon: '',
          breadcrumb: false,
          submenu: []
          },
          {
            key: 'student-drop',
            path: `${APP_PREFIX_PATH}/student/drop`,
            title: 'sidenav.student.drop',
            icon: '',
            breadcrumb: false,
            submenu: []
          },
          {
            key: 'student-problem',
            path: `${APP_PREFIX_PATH}/student/mathLabelChange`,
            title: 'Math Level Change Form',
            icon: '',
            breadcrumb: false,
            submenu: []
          },
          {
            key: 'student-englishLabelChange',
            path: `${APP_PREFIX_PATH}/student/englishLabelChange`,
            title: 'English Level Change Form',
            icon: '',
            breadcrumb: false,
            submenu: []
          },
      ]
    } ,
  ]
}
]

const personalManage = [{
  key: '',
  path: `${APP_PREFIX_PATH}/personal`,
  title: 'sidenav.personal',
  icon: '',
  breadcrumb: false,
  submenu: [
    {
      key: 'personal',
      path: `${APP_PREFIX_PATH}/personal`,
      title: 'sidenav.personal',
      icon: ReconciliationOutlined ,
      breadcrumb: false,
      submenu: [
        {
          key: 'personal-absentForm',
          path: `${APP_PREFIX_PATH}/personal/absentForm`,
          title: 'sidenav.personal.absentForm',
          icon: '',
          breadcrumb: false,
          submenu: []
        },
      ]
    }
  ]
}]

// const wsCheck = [{
//   key: '',
//   path: `${APP_PREFIX_PATH}/app`,
//   title: 'sidenav.wscheck',
//   icon: '',
//   breadcrumb: false,
//   submenu:[{
//     key: 'WS Check',
//     path: `${APP_PREFIX_PATH}/wsCheck`,
//     title: "sidenav.wscheck.home",
//     icon: MessageOutlined,
//     breadcrumb: false,
//     submenu: [],
//   }]
// }];
const navigationConfig = [
  ...dashBoardNavTree,
  ...studentManage,
  ...personalManage,
  // ...wsCheck,
]

export default navigationConfig;
